import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2893d33b")

_pushScopeId("data-v-2893d33b")
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "flex-grow flex flex-col justify-between h-screen" }
const _hoisted_3 = { class: "flex-grow flex flex-col items-center bg-primary-100 overflow-y-scroll pt-12" }
const _hoisted_4 = { class: "panel-container rounded-md bg-white pb-2" }
const _hoisted_5 = { class: "table-header-color w-full px-4 py-3 flex items-center justify-end lg:justify-between" }
const _hoisted_6 = { class: "hidden lg:flex" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, "教室追加", -1)
const _hoisted_8 = {
  key: 1,
  class: "flex"
}
const _hoisted_9 = { class: "flex-grow flex flex-col justify-between h-screen" }
const _hoisted_10 = { class: "flex-grow flex items-start justify-center bg-primary-100 overflow-y-auto px-4 pt-12" }
const _hoisted_11 = { class: "w-full max-w-2xl rounded-md bg-white px-6 py-10 text-center shadow-sm" }
const _hoisted_12 = /*#__PURE__*/_createVNode("h1", { class: "text-xl font-bold text-gray-800" }, " 教室管理画面が移動しました ", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("p", { class: "mt-4 text-gray-600 leading-7" }, [
  /*#__PURE__*/_createTextVNode(" 教室の確認・作成・編集は、"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" スクールAIの教室管理画面から行えます。 ")
], -1)
const _hoisted_14 = { class: "mt-8 flex justify-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MNavBar = _resolveComponent("MNavBar")
  const _component_MHeaderPanel = _resolveComponent("MHeaderPanel")
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_m_button = _resolveComponent("m-button")
  const _component_m_table = _resolveComponent("m-table")
  const _component_m_c_add_modal = _resolveComponent("m-c-add-modal")
  const _component_m_c_edit_modal = _resolveComponent("m-c-edit-modal")

  return (_ctx.isStudyRoomOnly)
    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
        _createVNode("div", _hoisted_1, [
          _createVNode(_component_MNavBar),
          _createVNode("div", _hoisted_2, [
            _createVNode(_component_MHeaderPanel, {
              title: "教室管理",
              breadcrumbs: []
            }),
            _createVNode("main", _hoisted_3, [
              _createVNode("section", _hoisted_4, [
                _createVNode("div", _hoisted_5, [
                  _createVNode("div", _hoisted_6, [
                    _withDirectives(_createVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchKeyword = $event)),
                      type: "search",
                      name: "searchClassroom",
                      placeholder: "教室名で検索...",
                      class: "w-60 bg-white rounded border border-white focus:border-primary-500 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-300"
                    }, null, 512), [
                      [_vModelText, _ctx.searchKeyword]
                    ])
                  ]),
                  (_ctx.isAdminOfSchool)
                    ? (_openBlock(), _createBlock(_component_m_button, {
                        key: 0,
                        color: "primary-500",
                        "hover-color": "primary-600",
                        onClick: _ctx.showAddModal
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_m_icon, {
                            type: "plus",
                            width: "4",
                            class: "mr-2"
                          }),
                          _hoisted_7
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_m_table, {
                  datas: _ctx.filteredDatas,
                  definitions: _ctx.definitions,
                  "default-sort-key": "studentNum",
                  editable: "",
                  onSelect: _ctx.changeSelectedId
                }, null, 8, ["datas", "definitions", "onSelect"])
              ])
            ])
          ])
        ]),
        (_ctx.isDisplayedAddClassroomModal)
          ? (_openBlock(), _createBlock(_component_m_c_add_modal, {
              key: 0,
              tutors: _ctx.tutors,
              onClose: _ctx.closeAddModal
            }, null, 8, ["tutors", "onClose"]))
          : _createCommentVNode("", true),
        (_ctx.isDisplayedEditClassroomModal && _ctx.selectedClassroom)
          ? (_openBlock(), _createBlock(_component_m_c_edit_modal, {
              key: 1,
              classroom: _ctx.selectedClassroom,
              tutors: _ctx.tutors,
              onClose: _ctx.closeEditModal
            }, null, 8, ["classroom", "tutors", "onClose"]))
          : _createCommentVNode("", true)
      ], 64))
    : (_openBlock(), _createBlock("div", _hoisted_8, [
        _createVNode(_component_MNavBar),
        _createVNode("div", _hoisted_9, [
          _createVNode(_component_MHeaderPanel, {
            title: "教室管理",
            breadcrumbs: []
          }),
          _createVNode("main", _hoisted_10, [
            _createVNode("section", _hoisted_11, [
              _hoisted_12,
              _hoisted_13,
              _createVNode("div", _hoisted_14, [
                _createVNode("a", {
                  href: _ctx.newClassroomManagementUrl,
                  class: "inline-flex items-center rounded-md font-medium text-sm transition-all duration-300 px-4 py-2 text-white bg-primary-500 hover:bg-primary-600 cursor-pointer"
                }, " 新しい教室管理画面を開く ", 8, ["href"])
              ])
            ])
          ])
        ])
      ]))
})